import React, { useState, useEffect } from "react";
import i18n from "i18next";

import { fetchWrapper } from "../../helpers/fetchwrapper";

// Fluent UI Imports
import { baseUrl } from "../../helpers/constants";
import { IKonfigurationSt } from "../../Models/IKonfigurationSt";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  Field,
  Input,
} from "@fluentui/react-components";
import { SaveRegular } from "@fluentui/react-icons";

interface ISaveResultDialogProps {
  finishedConfig: IKonfigurationSt | undefined;
  isDialogOpen: boolean;
  onDismiss: any;
  onSave: any;
}

function SaveResultDialog(props: ISaveResultDialogProps) {
  const [finishedConfig, setFinishedConfig] = useState<
    IKonfigurationSt | undefined
  >(props.finishedConfig);

  const [disableButton, setDisableButtons] = useState<boolean>(false);

  const [hasError, setError] = useState(false);

  const handleFinishedConfigValuesChange = (name: string, val: any) => {
    setFinishedConfig((prevState: any) => ({
      ...prevState,
      [name]: val,
    }));
  };

  useEffect(() => {
    setFinishedConfig(props.finishedConfig);
  }, [props.finishedConfig]);

  const SaveConfiguration = () => {
    if (finishedConfig) {
      setDisableButtons(true);
      fetchWrapper
        .postWithAuth(
          baseUrl + "/api/configurator/SaveKonfiguration",
          finishedConfig,
        )
        .then((result: any) => {
          props.onSave(result);
        })
        .catch(() => {
          setDisableButtons(true);
          setError(true);
        })
        .finally(() => {
          setDisableButtons(false);
        });
    }
  };

  const isSaveDisabled = () => {
    if (finishedConfig?.kommentar) {
      if (
        finishedConfig?.kommentar.length < 4 &&
        finishedConfig?.kommentar.length > 199
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };

  return (
    <Dialog open={props.isDialogOpen}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{i18n.t<string>("saveConfigDialog")}</DialogTitle>
          <DialogContent>
            {i18n.t<string>("saveConfigDialogSubText")}
            <Field
              style={{ marginTop: "10px", fontWeight: 700 }}
              label={i18n.t<string>("kommentar")}
              validationMessage={
                hasError ? i18n.t<string>("somethingWentWrong") : ""
              }
            >
              <Input
                value={finishedConfig?.kommentar}
                onChange={(ev, val) => {
                  handleFinishedConfigValuesChange("kommentar", val.value);
                }}
              />
            </Field>
            {/* {hasError && (
              <div style={{ marginTop: 10 }}>
                <MessageBar messageBarType={MessageBarType.error}>
                  {}
                </MessageBar>
              </div>
            )} */}
          </DialogContent>
          <DialogActions>
            <Button
              appearance="primary"
              disabled={isSaveDisabled() || disableButton || hasError}
              onClick={() => SaveConfiguration()}
              icon={<SaveRegular />}
            >
              {i18n.t<string>("save")}
            </Button>
            <Button
              disabled={disableButton}
              onClick={() => {
                props.onDismiss(true);
              }}
            >
              {i18n.t<string>("cancel")}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}

export default SaveResultDialog;
